import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './member-topup.component.html',
  styleUrls: ['./member-topup.component.scss']
})
export class MemberTopupDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<MemberTopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) {}

  ngOnInit() {
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

}
